import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@deseretbook/react-ui'

/**
 * Renders an address.
 *
 * @param {object} param - Component parameters
 * @returns {function} Component
 */
const Address = ({ address }) => {
  if (!address) {
    return false
  }

  return (
    <address>
      <Text isBold hasEllipsis>
        {address.displayName
          ? address.displayName
          : `${address.firstname} ${address.lastname}`
        }
      </Text>
      <Text hasEllipsis>{address.address1}</Text>
      {!!address.address2 && <Text hasEllipsis>{address.address2}</Text>}
      {!!address.address3 && <Text hasEllipsis>{address.address3}</Text>}
      <Text hasEllipsis>
        {[
          address.city,
          address.stateName || (address.state && address.state.name),
          address.country && address.country.name,
          address.zipcode || address.zip,
        ]
          .filter(Boolean)
          .join(', ')
        }
      </Text>
    </address>
  )
}

Address.propTypes = {
  address: PropTypes.shape({
    displayName: PropTypes.string,
    firstname: PropTypes.string,
    lastname: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    address3: PropTypes.string,
    city: PropTypes.string,
    stateName: PropTypes.string,
    state: PropTypes.shape({
      name: PropTypes.string,
    }),
    country: PropTypes.shape({
      name: PropTypes.string,
    }),
    zipcode: PropTypes.string,
    zip: PropTypes.string,
  }),
}

Address.defaultProps = {
  address: {},
}

export default Address
